<template>
  <v-container>
    <ClassGroupTable
      :item="{ name: title, fbpath: collectionName }"
    ></ClassGroupTable>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
const fb = require("@/firebaseConfig.js");

export default {
  data: () => ({
    stab: null,
    collectionName: "xprofessions",
    title: "Багш, aжилтан",
  }),
  components: {
    ClassGroupTable: () => import("./ClassGroupTable"),
  },
  computed: {
    ...mapState(["userProfile", "currentUser", "xxschool"]),
  },
  created() {},
  methods: {},
};
</script>
